import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { FileText, Clock } from 'lucide-react';

export function ClientCaseStatusTab({ caseInfo, statusHistory, formatDate, getStatusColor }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <Card>
        <CardHeader>
          <CardTitle className="font-heading text-lg flex items-center gap-2">
            <FileText className="w-5 h-5 text-primary" />
            Case Details
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between p-3 bg-secondary/50 rounded-lg">
            <span className="font-body text-sm text-muted-foreground">Status</span>
            <span className={`px-3 py-1 rounded-full text-sm font-body font-medium ${getStatusColor(caseInfo.status)}`}>
              {caseInfo.status || 'Active'}
            </span>
          </div>
          <div className="flex items-center justify-between p-3 bg-secondary/50 rounded-lg">
            <span className="font-body text-sm text-muted-foreground">Service Type</span>
            <span className="font-body font-medium">{caseInfo.type_of_services || 'N/A'}</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-secondary/50 rounded-lg">
            <span className="font-body text-sm text-muted-foreground">A-Number</span>
            <span className="font-body font-medium">{caseInfo.a_number || 'N/A'}</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-secondary/50 rounded-lg">
            <span className="font-body text-sm text-muted-foreground">USCIS Receipt</span>
            <span className="font-body font-medium">{caseInfo.uscis_receipt || 'N/A'}</span>
          </div>
          {caseInfo.biometrics_date && (
            <div className="flex items-center justify-between p-3 bg-primary/10 rounded-lg border border-primary/20">
              <span className="font-body text-sm text-primary">Biometrics Appointment</span>
              <span className="font-body font-medium text-primary">{formatDate(caseInfo.biometrics_date)}</span>
            </div>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="font-heading text-lg flex items-center gap-2">
            <Clock className="w-5 h-5 text-primary" />
            Status History
          </CardTitle>
        </CardHeader>
        <CardContent>
          {statusHistory.length === 0 ? (
            <p className="font-body text-sm text-muted-foreground text-center py-4">No status updates yet</p>
          ) : (
            <div className="space-y-3 max-h-64 overflow-y-auto">
              {statusHistory.map((status, idx) => (
                <div key={status.id || idx} className="flex items-start gap-3 p-3 border-l-2 border-primary/30 pl-4">
                  <div className="flex-1">
                    <p className="font-body font-medium text-sm">{status.status}</p>
                    {status.notes && <p className="font-body text-xs text-muted-foreground">{status.notes}</p>}
                    <p className="font-body text-xs text-muted-foreground mt-1">{formatDate(status.created_at)}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
